<section [ngClass]="dynamicClass">
  <div class="eq-container">
    <div class="eq-rich-content eq-w-full eq-text-blue-darkBlue lg:eq-w-4/5 eq-mx-0 lg:eq-mx-auto eq-text-intro-m lg:eq-text-intro" *scRichText="rendering.fields.Text"></div>
  </div>
</section>
